import SGMap from './SGMap'

const apply = ($) => !!$('[data-node-type="recruiting_map_only"]').get(0)

let mapInitialized = false

const showMapView = () => {
  if (mapInitialized) {
    return
  }

  mapInitialized = true
  const locations = $('[data-locations]').data('locations')

  const sgMap = new SGMap(locations, 'recruiting', $('[data-job-listing-map]').get(0), $('[data-infobox-tmpl]').html())

  const jobsPageURL = $('[data-jobs-page-url]').data('jobs-page-url')

  // click in info window link
  $('body').on('SGMap.filterByloctionID', function(e, locID) {
    location.href = `${jobsPageURL}?active_view=map&q[location_id_eq]=${locID}`
  })
}

const setup = ($) => {
  if (!apply($)) {
    return
  }
  showMapView($)
}

export default setup



// WEBPACK FOOTER //
// app/javascript/sg/js/node_recruiting_map_only.js